export default __webpack_public_path__ + "static/media/legaldhanda.9b3325a1.png";